import { useEffect, useState } from "react";
import axios from "axios";
import { order } from "../../components/apipath";
import { dateHelper } from "../../modules/helpers";

function OrderList() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchOrders = async () => {
        try {
            const response = await axios.get(`${order}list`);
            setOrders(response.data);
        } catch (error) {
            console.error("載入訂單資料失敗：", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders();
    }, []);

    const getCouponLabel = (order) => {
        if (order.discount_code) return `Discount - ${order.discount_code}`;
        if (order.mou_code) return `MOU - ${order.mou_code}`;
        return "—";
    };

    return (
        <div className="container-fluid p-5 mt100">
            <h2>訂單管理</h2>
            {loading ? (
                <p>資料載入中...</p>
            ) : (
                <table className="table table-striped border table-responsive">
                    <thead>
                        <tr>
                            <th>訂單編號</th>
                            <th>學員姓名</th>
                            <th>產品名稱</th>
                            <th>優惠碼</th>
                            <th>價格</th>
                            <th>統編</th>
                            <th>公司</th>
                            <th>領書選擇</th>
                            <th>上課方式</th>
                            <th>寄送科目</th>
                            <th>寄送地址</th>
                            <th>匯款人</th>
                            <th>匯款日</th>
                            <th>下單日</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order) => (
                            <tr key={order.order_id}>
                                <td>{order.order_id}</td>
                                <td>{order.student_name}</td>
                                <td>{order.product_name}</td>
                                <td>{getCouponLabel(order)}</td>
                                <td>NT${order.total_price}</td>
                                <td>{order.tax_num || "—"}</td>
                                <td>{order.company || "—"}</td>
                                <td>{order.deliver || "—"}</td>
                                <td>{order.course || "—"}</td>
                                <td>{order.book || "—"}</td>
                                <td>{order.address || "—"}</td>
                                <td>{order.transfer_name || "—"}</td>
                                <td>{order.transfer_date ? dateHelper(order.transfer_date, "date") : "—"}</td>
                                <td>{order.order_date ? dateHelper(order.order_date, "date") : "—"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default OrderList;